import React, { useEffect, useRef, useState } from "react";
import "./PhishingAdvisoryModal.css";

function PhishingAdvisoryModal() {
  const [open, setOpen] = useState(true);
  const acknowledgeRef = useRef(null);

  const close = () => setOpen(false);

  useEffect(() => {
    if (!open) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    acknowledgeRef.current?.focus();

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        close();
      }
    };
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="phishing-advisory-overlay"
      role="presentation"
      onClick={close}
    >
      <div
        className="phishing-advisory-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="phishing-advisory-title"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id="phishing-advisory-title" className="visually-hidden">
          Public Advisory: Phishing Email Warning
        </h2>
        <button
          type="button"
          className="phishing-advisory-close"
          aria-label="Close advisory"
          onClick={close}
        >
          ×
        </button>
        <div className="phishing-advisory-body">
          <img
            className="phishing-advisory-image"
            src="/phishing-advisory.jpg"
            alt="Bureau of Immigration public advisory warning about fraudulent Landbank iAccess emails. Do not click links or attachments, do not reply, and do not provide personal or banking information. Report the message as phishing and stay vigilant."
          />
        </div>
        <div className="phishing-advisory-footer">
          <button
            ref={acknowledgeRef}
            type="button"
            className="btn btn-light phishing-advisory-ack"
            onClick={close}
          >
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
}

export default PhishingAdvisoryModal;
